/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

export interface CancelIconProps extends IconProps {
  disable?: boolean,
  opacity?: number
}

/*
 * Defines the Design Language System (DLS) CancelIcon Icon component.
 */
export const CancelIcon = (props: CancelIconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  const {disable, opacity}  = props;
  
  return (
    <svg width={iconSize} height={iconSize} opacity={disable ? opacity ?? 0.2 : 1} viewBox="0 0 24 24">
      <path fill={iconColor}
        d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z" />
    </svg>
  );
};

export default CancelIcon;
